import styled from 'styled-components';
import { colors } from '../../../base/styled/variables.styled';
import { typography } from '../../../base/styled/typography.style';
export const CardContainer = styled.div `
  background-color: ${({ $inverse }) => $inverse ? colors.neutral900 : colors.neutral000};
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  width: 280px;
  min-width: 280px;
  max-width: 280px;
  box-sizing: border-box;
`;
export const ImageColumn = styled.div `
  width: 100%;
  height: 194px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const InfoColumn = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  padding: 0 8px;
`;
export const InfoItem = styled.div.withConfig({
    shouldForwardProp: (prop) => !['inverse', '$inverse'].includes(prop),
}) `
  ${typography.body2};
  color: ${({ $inverse }) => $inverse ? colors.neutral200 : colors.neutral800};
  
  strong {
    ${typography.body2Highlight};
    color: ${({ $inverse }) => $inverse ? colors.neutral100 : colors.neutral600};
    margin-right: 4px;
  }
`;
export const ActionColumn = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
`;
//# sourceMappingURL=CourseDetailEnrollmentCard.style.js.map